import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { injectStateService, StateService } from '@/shared/services/StateService';
import RecentRelationsService from '@/shared/services/RecentRelationsService';
import { getRelationName, getRelationNameCode } from '@/shared/components/RelationName';
import intlShape from '@/shared/utils/intlShape';

import messages from '../dashboardMessages';

const RecentRelationsDashboard = ({ intl, stateService }) => {
  const [relations] = useState(RecentRelationsService.get());

  return (
    <div className="recent-relations-dashboard">
      <div className="title-block">
        <FormattedMessage {...messages.RecentRelations} />
      </div>
      <div className="content-block">
        <div className="relations">
          {relations &&
            relations.map(relation => {
              const name = getRelationName(intl, relation);
              const nameCode = getRelationNameCode(intl, relation);

              return (
                <a
                  key={relation.id}
                  href={stateService.gotoRelationHref(relation.id)}
                  onClick={() => stateService.gotoRelation(relation.id)}
                >
                  <div className="name bold no-overflow text-nowrap" title={nameCode}>
                    {name}
                  </div>
                  {relation.location ? (
                    <div className="location no-overflow text-nowrap" title={relation.location}>
                      {relation.location}
                    </div>
                  ) : null}
                </a>
              );
            })}
        </div>
      </div>
    </div>
  );
};
RecentRelationsDashboard.propTypes = {
  intl: intlShape.isRequired,
  stateService: PropTypes.instanceOf(StateService).isRequired,
};

export default injectStateService(injectIntl(RecentRelationsDashboard));
